// Module
var code = "<react-component name=\"EnrolledSequencesReport\"></react-component>\n";
// Exports
module.exports = code;